import {
  isFunction
} from "./chunk-QWVYBC6R.mjs";

// src/function.ts
var noop = () => {
};
function runIfFunc(valOrFunc, ...args) {
  return isFunction(valOrFunc) ? valOrFunc(...args) : valOrFunc;
}
function handlerAll(...funcs) {
  return function(event, ...args) {
    funcs.some((func) => {
      func == null ? void 0 : func(event, ...args);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}
function funcAll(...funcs) {
  return function(...args) {
    return funcs.forEach((func) => func == null ? void 0 : func(...args));
  };
}

export {
  noop,
  runIfFunc,
  handlerAll,
  funcAll
};
//# sourceMappingURL=chunk-23I7TQOH.mjs.map